import request from "_private/utils/request";

/**
 * 获取列表数据
 * @param {*} data
 */
export function FetchByPage(data) {
  return request({
    url: "/system/interfaceDocumentCenter/findByPage",
    method: "post",
    headers: { type: "json" },
    data
  });
}
/**
 * 下载文件
 * @param {*} data
 */
export function DownloadFile(params) {
  return request({
    url: `/app/file/download`,
    method: "get",
    responseType: "blob",
    headers: { "Content-Type": "application/json" },
    params
  });
}
//获取接口名称
export function FetchInterfaceName() {
  return request({
    url: " /base/interfaceCenter/findAllInterfaceInfo",
    method: "post"
  });
}
